import React from 'react'
import { Link } from 'react-router-dom';

function Services() {
  return (
    <div>
          <section id="services" class="services section-bg ">
                <div class="container" data-aos="fade-up">

                <div class="section-title">
                    <h2>Services</h2>
                    <p>Our 3D Laser Scanning Solution & Services Include</p>
                </div>

                <div class="row">
                    <div class="col-md-6">
                    <Link to="/BuildDocmentation">
                    <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
                        <i class="bi bi-file-earmark-richtext-fill"></i>
                        <h4><a href="#">As-Built Documentation</a></h4>
                        <p>Documentation of the actual state of a building</p>
                    </div>
                    </Link>
                    </div>
                    <div class="col-md-6 mt-4 mt-md-0">
                    <Link to="/PointCloudModeling">
                    <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
                        <i class="bi bi-cloud-upload-fill"></i>
                        <h4><a href="#">Point Cloud Modeling</a></h4>
                        <p>Physical dimensions of the surfaces of buildings and objects</p>
                    </div>
                    </Link>
                    </div>
                    <div class="col-md-6 mt-4 mt-md-0">
                    <Link to="#IndustrialScanningServices">
                    <div class="icon-box" data-aos="fade-up" data-aos-delay="300">
                        <i class="bi bi-buildings"></i>
                        <h4><a href="#">Industrial Scanning Services</a></h4>
                        <p>To capture data on existing structures, equipment, utilities</p>
                    </div>
                    </Link>
                    </div>
                    <div class="col-md-6 mt-4 mt-md-0">
                    <Link to="/ConstructionScanningServices">
                    <div class="icon-box" data-aos="fade-up" data-aos-delay="400">
                        <i class="bi bi-cone-striped"></i>
                        <h4><a href="#">Construction Scanning Services</a></h4>
                        <p>To capture the details of an existing building or construction site</p>
                    </div>
                    </Link>
                    </div>
                  
                </div>

                </div>
        </section>

    </div>
  )
}

export default Services